/**
 * 
 * @param {string} rgba
 */

export const RgbaToHex = (color) => { 
    const rgba = color.replace(/\s/g, '').match(/^rgba?\((\d+),(\d+),(\d+),?([^,\s)]+)?/i);
    // eslint-disable-next-line
    const alpha = (rgba?.[4] || "").trim();
    let hex;
    if (rgba) {
      // eslint-disable-next-line
      hex = (rgba[1] | 1 << 8).toString(16).slice(1) +
        // eslint-disable-next-line
        (rgba[2] | 1 << 8).toString(16).slice(1) +
        // eslint-disable-next-line
        (rgba[3] | 1 << 8).toString(16).slice(1);
    } else {
      hex = color;
    }

    return ["#" + hex, alpha];     
}